module.exports = __webpack_public_path__ + "img/2024-ford-e-transit.a98aa060.png";